// Theme Main JS
import '../vendor/brooklyn';

// Styles
import '../../styles/style.scss';

// Scripts
import '../vendor/slick/slick.js';
import '../vendor/ProxyLink.js';
import '../vendor/TimedPopUp.js';
import '../vendor/parsley.js';
import Tabs from '../components/tabs.js';
import '../components/gsap-collapse.js';
//import '../components/sparkle';
import '../components/knitkit.js';
import '../components/input.js';
import '../components/header.js';
import '../components/drawer.js';
import '../components/facets.js';
import '../components/$.ClipIt.js'; 
import NewsletterForm from '../components/newsletter-form.js';
import '../sections/slideshow.js';
import '../sections/images-with-text.js';
import '../sections/collaboration.js';
import '../sections/hero-cards.js';
import '../sections/collection-carousel.js';
import '../sections/collection-template.js';
import '../sections/section-article-list.js';
import '../snippets/contact-form.js';
//import '../sections/featured-products.js';
import '../sections/featured-description.js';
import '../sections/template_product.js';
import '../sections/three-images.js';
import '../sections/instagram-feed.js';
import '../snippets/product-tile.js';
import '../sections/template_cart.js';
import '../snippets/wishlist.js';
import '../sections/section-text-column.js';
//import '../snippets/dataLayer.js';
import '../sections/video-script.js';
import '../sections/slider.js';
import '../sections/product-size.js';

$(document).on('ready', function() {
    Tabs();
    NewsletterForm();

    if(typeof window.Ajaxinate !== 'undefined' && document.getElementById('AjaxinateContainer')) {

        var anchorStart = window.location.href.indexOf('#');
        var itemID = anchorStart != -1 ? window.location.href.substr(anchorStart) : ''
        var preLoadingEnded = true; // Flag to check if were loading back pages
        var ajaxPageParamStart = window.location.href.indexOf('?i=');
        var ajaxPageParamEnd = anchorStart != -1 ? window.location.href.length - anchorStart : undefined;
        var ajaxPageNumber = ajaxPageParamStart != -1 ? parseInt(window.location.href.substr(ajaxPageParamStart, ajaxPageParamEnd).replace('?i=', '')) : false;

        var preLoadNextPage = function() {
            window.endlessScroll.currentPage++
            window.endlessScroll.pagesToLoad--;

            window.setTimeout(function(){
                if(window.endlessScroll.nextPageLinkElement){
                    window.endlessScroll.nextPageUrl = window.endlessScroll.nextPageLinkElement.getAttribute('href');
                    window.endlessScroll.loadMore();
                }
            }, 10); // Please lord of javascript forgive me for this!

            console.log(window.endlessScroll.pagesToLoad);

            if(!window.endlessScroll.pagesToLoad) {
                preLoadingEnded = true;
            }
        }

        window.endlessScroll = new Ajaxinate({
          container: '#AjaxinateContainer',
          pagination: '#AjaxinatePagination',
          method: 'click',
          callback: function(request){
                var $proxyLinks = $('#AjaxinateContainer').find('[data-link-proxy]');
                if($proxyLinks.length) {
                    $proxyLinks.off('click');

                    $proxyLinks.ProxyLink({
                        excludes: ['.slick-dots', '.product-tile__variant', '.swym-add-to-wishlist-view-product' ],
                        onBeforeUnload: function($proxyLink) {
                            const itemID = $proxyLink.attr('id');
                            if(itemID) {
                                const requestedPageNum = window.location.href.substr(window.location.href.indexOf('?page=')).replace('?page=', '')
                                history.pushState({}, 'page ' + requestedPageNum, '?i='+requestedPageNum + '#' + itemID);
                            }
                        }
                    });
                }

                // Init wishlist buttons
                document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

                // Scroll back to latest position
                var requestedPageNum = request.URL.split('?')[1].split('&').filter(el => el.startsWith('page='))[0].split('=')[1];
                var url_to_merge = request.URL.split('?')[1].replace(`&page=${requestedPageNum}`, '').replace(`?page=${requestedPageNum}`, '');

                if (url_to_merge.includes('page=')) url_to_merge = '';

                if(preLoadingEnded) {
                    window.endlessScroll.currentPage = requestedPageNum;
                    history.pushState({}, 'page ' + requestedPageNum, '?i='+requestedPageNum + url_to_merge + itemID);
                }

                if(!window.endlessScroll.pagesToLoad) {
                    const headersHeight = $('.site-header').outerHeight(true);

                    if(itemID) {
                        var itemTop = $(itemID).offset().top - headersHeight;
                        window.scrollTo({left:0, top:itemTop, behavior: 'smooth'});
                        itemID = '';
                    }
                }

                if(window.endlessScroll.pagesToLoad) {
                    preLoadNextPage();
                }
            }
        });

        window.endlessScroll.currentPage = 1;

        if(ajaxPageNumber) {
            window.scrollTo({left:0, top: 0});
            preLoadingEnded = false;
            window.endlessScroll.pagesToLoad = ajaxPageNumber - 1;
            preLoadNextPage();
        }
    }

    $('[data-timed-popup]').TimedPopup();

    const $orderLists = $('[data-order-list]');
    if($orderLists.length) {
        $orderLists.each(function(){
            const $list = $(this);
            $list.find('[data-order-number]').sort(function(a, b) {
                return +a.dataset.orderNumber - +b.dataset.orderNumber;
            })
            .appendTo($list);
        });
        window.setTimeout(function(){
            $orderLists.attr('data-order-list', 'ready');
        }, 50);
    }
});






